export default __webpack_public_path__ + "static/media/no-propertyfound.234697c0.png";